import {atom} from "jotai";

export const ConfirmModalAtom = atom({
  open: false,
  title: "Are you sure?",
  message: "",
  confirmText: "Yes",
  cancelText: "No",
  confirmStyle: {},
  cancelStyle: {},
  resolve: null,
});